import { DynamicField } from "./dynamic-field.model";

export class DynamicGeneric<T> extends DynamicField<T> {
    text?: string;

    constructor(source: Partial<DynamicGeneric<T>>) {
        super();
        Object.assign(this, source);
    }
}